// store/modules/pagination.js

const state = {
  perPage: 10 // 기본값 설정
};

const mutations = {
  SET_PER_PAGE(state, value) {
    state.perPage = value;
  }
};

const actions = {
  updatePerPage({ commit }, value) {
    commit('SET_PER_PAGE', value);
  }
};

const getters = {
  perPage: state => state.perPage
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
